import React from 'react';
import { Button, Modal, ModalProps } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { Form, Formik } from 'formik';
import { object, number, string } from 'yup';
import { map } from 'lodash';

import { FormGroupControl, FormGroupSelect } from '@components/Base';
import { CashFlows } from '@models/PolicyCommissionInvoice';

import { PolicyCommissionInvoiceCreatePayload } from './action';

export type PolicyCommissionInvoiceFormValues = Pick<PolicyCommissionInvoiceCreatePayload, 'totalPremium' | 'cashFlow'>;

const GROUP_PROPS = { className: 'mb-3' };

type FormFormProps = Pick<ModalProps, 'onHide'>;

const FormForm = ({ onHide }: FormFormProps) => {
  const { t } = useTranslation();

  return (
    <Form>
      <Modal.Header closeButton>
        <Modal.Title>New Invoice</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <FormGroupControl
          asRow
          type="number"
          label="Total premium"
          name="totalPremium"
          required
          groupProps={GROUP_PROPS}
        />
        <FormGroupSelect
          asRow
          label="Cash flow"
          name="cashFlow"
          required
          groupProps={GROUP_PROPS}
        >
          <option></option>
          {map(CashFlows, (cashFlow) => (
            <option key={cashFlow} value={cashFlow}>
              {cashFlow}
            </option>
          ))}
        </FormGroupSelect>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          {t('confirmModal.cancel')}
        </Button>
        <Button type="submit" variant="primary">
          {t('common:save')}
        </Button>
      </Modal.Footer>
    </Form>
  );
}

type Props = ModalProps & {
  onSubmit: (values: PolicyCommissionInvoiceFormValues) => void;
}

const PolicyCommissionInvoiceFormModal = ({ onSubmit, ...props }: Props) => {
  const { t } = useTranslation();

  const validationSchema = object({
    totalPremium: number().required(t('validation:required')),
    cashFlow: string().required(t('validation:required')),
  });

  const initialValues: PolicyCommissionInvoiceFormValues = {
    totalPremium: '',
    cashFlow: '',
  };

  return (
    <Modal {...props}>
      <Formik
        initialValues={initialValues}
        onSubmit={onSubmit}
        validationSchema={validationSchema}
      >
        <FormForm onHide={props.onHide} />
      </Formik>
    </Modal>
  )
};

export { PolicyCommissionInvoiceFormModal };
